<template>
  <div>
    <app-echart-doughnut :series="series" style="width: 100%" />

    <div
      class="d-flex justify-content-between flex-sm-row flex-column mb-sm-0 mb-1 mt-1"
    >
      <small></small>
      <small class="timeline-item-time text-nowrap text-muted ml-1"
        >Source: Insee
        {{
          this.demographyByPeriode.data[
            this.demographyByPeriode.data.length - 1
          ].year
        }}</small
      >
    </div>
  </div>
</template>

<script>
import AppEchartDoughnut from "@core/components/charts/echart/AppEchartDoughnut.vue";

export default {
  components: {
    AppEchartDoughnut,
  },
  props: {
    demographyByPeriode: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      series: [
        {
          name: "Répartition des logements",
          type: "pie",
          radius: ["45%", "65%"],
          avoidLabelOverlap: true,
          tooltip: {
            formatter: "{a} <br/>{b} : {d}%",
          },
          label: {
            show: true,
            formatter: "{name|{b}}\n{percent|{d}%}",
            minMargin: 5,
            edgeDistance: 10,
            fontSize: 14,
            lineHeight: 15,
            rich: {
              percent: {
                fontSize: 12,
                color: "#999",
              },
            },
          },
          labelLine: {
            show: true,
            length: 15,
            length2: 15,
            maxSurfaceAngle: 50,
          },
          data: [
            {
              value:
                this.demographyByPeriode.data[
                  this.demographyByPeriode.data.length - 1
                ].lodgment.division.apartment_rate,
              name: "Appartement",
            },
            {
              value:
                this.demographyByPeriode.data[
                  this.demographyByPeriode.data.length - 1
                ].lodgment.division.house_rate,
              name: "Maison",
            },
          ],
        },
      ],
    };
  },
};
</script>

<style lang="scss"></style>
